export interface PayoutReceiptDetail {
    receiptAvailable?: boolean
}

export const canGeneratePayoutReceipt = (detail: PayoutReceiptDetail): boolean =>
    detail.receiptAvailable === true
